<template>
  <img
    :src="`/image/${active ? activeIcon : icon}`"
    class="sidebar-menu-icon"
    alt="icon"
  />
</template>

<script>
export default {
  name: 'SidebarMenuIcon',
  props: {
    icon: { type: String, required: true }, // 非激活icon
    activeIcon: { type: String, required: true }, // 激活icon
    active: { type: Boolean, default: false }
  }
}
</script>

<style scoped>
.sidebar-menu-icon {
  width: 32px;
  height: 32px;
  margin-right: 8px;
  vertical-align: middle;
}
</style>
